import { FieldTypes } from "./../../../../../store/fields/types";

// IF
const textCommon = {
    IS: "Is",
    IS_NOT: "Is not",
    CONTAINS: "Contains",
    DOES_NOT_CONTAIN: "Doesn't contain",
    BEGINS_WITH: "Begins with",
    DOES_NOT_BEGIN_WITH: "Doesn't begin with",
    ENDS_WITH: "Ends with",
    DOES_NOT_END_WITH: "Doesn't end with",
    IS_EMPTY: "Is empty",
    IS_FILLED: "Is filled",
};

const simpleInputsCommon = { IS_EMPTY: "Is empty", IS_FILLED: "Is filled" };

const inputCommon = { IS: "Is", IS_NOT: "Is not", IS_EMPTY: "Is empty", IS_FILLED: "Is filled" };

const numberInputCommon = {
    IS: "Is",
    IS_NOT: "Is not",
    CONTAINS: "Contains",
    DOES_NOT_CONTAIN: "Doesn't contain",
    IS_EMPTY: "Is empty",
    IS_FILLED: "Is filled",
    LESS_THAN: "Less than",
    GREATER_THAN: "Greater then",
};

const ratingCommon = {
    IS_EMPTY: "Is empty",
    IS_FILLED: "Is filled",
    LESS_THAN: "Less than",
    GREATER_THAN: "Greater then",
};

const timeCommon = {
    IS: "Is",
    IS_NOT: "Is not",
    BEFORE: "Before",
    AFTER: "After",
    IS_EMPTY: "Is empty",
    IS_FILLED: "Is filled",
};

const checkboxCommon = {
    IS: "Is",
    IS_NOT: "Is not",
    QUANTITY: "Quantity",
    IS_EMPTY: "Is empty",
    IS_FILLED: "Is filled",
};

const dateCommon = {
    IS_EMPTY: "Is empty",
    IS_FILLED: "Is filled",
    BEFORE: "Before",
    AFTER: "After",
    IS_EQUAL_TO_DATE: "Is equal to date",
    IS_NOT_EQUAL_TO_DATE: "Is not equal to date",
    IS_EQUAL_TO_DAY: "Is equal to day",
    IS_NOT_EQUAL_TO_DAY: "Is not equal to day",
};

// THEN
export enum LoginActions {
    SHOW = "Show",
    HIDE = "Hide",
    SHOW_PAGE = "Show page",
    HIDE_PAGE = "Hide page",
    SENT_TO_OTHER_EMAIL = "Send to other email",
    //REQUIRED = "Required",
    //UNREQUIRED = "Unrequired",
    //COPY_FIELD_VALUE = "Copy field's value",
    //CALCULATE = "Calculate",
    //SEND_EMAIL_TO_RESPONDENT = "Send email to respondent",
}

const anotherCommon = [
    FieldTypes.INPUT_MULTI_LINE_TEXT,
    FieldTypes.SINGLE_LINE_TEXT,
    FieldTypes.PASSWORD,
    FieldTypes.TIMEZONE,
    FieldTypes.DROPDOWN,
    FieldTypes.CHECKBOX,
    FieldTypes.ADDRESS,
    FieldTypes.NUMBER,
    FieldTypes.PHONE,
    FieldTypes.PRICE,
    FieldTypes.EMAIL,
    FieldTypes.NAME,
    FieldTypes.DATE,
    FieldTypes.RADIO,
    FieldTypes.SCALE_RATING,
    FieldTypes.STAR_RATING,
    FieldTypes.TERMS,
    FieldTypes.TIME,
    FieldTypes.URL,
];

const anotherEmailType = [
    FieldTypes.INPUT_MULTI_LINE_TEXT,
    FieldTypes.SINGLE_LINE_TEXT,
    FieldTypes.DROPDOWN,
    FieldTypes.CHECKBOX,
    FieldTypes.EMAIL,
    FieldTypes.RADIO,
];

const anotherPriceType = [
    FieldTypes.INPUT_MULTI_LINE_TEXT,
    FieldTypes.SINGLE_LINE_TEXT,
    FieldTypes.DROPDOWN,
    FieldTypes.CHECKBOX,
    FieldTypes.NUMBER,
    FieldTypes.PRICE,
    FieldTypes.RADIO,
];

const anotherUrlType = [
    FieldTypes.INPUT_MULTI_LINE_TEXT,
    FieldTypes.SINGLE_LINE_TEXT,
    FieldTypes.DROPDOWN,
    FieldTypes.CHECKBOX,
    FieldTypes.RADIO,
    FieldTypes.URL,
];

const anotherNumberType = [
    FieldTypes.INPUT_MULTI_LINE_TEXT,
    FieldTypes.SINGLE_LINE_TEXT,
    FieldTypes.DROPDOWN,
    FieldTypes.CHECKBOX,
    FieldTypes.RADIO,
    FieldTypes.SCALE_RATING,
    FieldTypes.STAR_RATING,
    FieldTypes.NUMBER,
    FieldTypes.PRICE,
];

const anotherTimezoneType = [FieldTypes.DROPDOWN, FieldTypes.CHECKBOX, FieldTypes.RADIO, FieldTypes.TIMEZONE];

const anotherRatingType = [FieldTypes.STAR_RATING, FieldTypes.SCALE_RATING, FieldTypes.NUMBER];

const anotherChoicesType = [
    FieldTypes.DROPDOWN,
    FieldTypes.CHECKBOX,
    FieldTypes.RADIO,
    FieldTypes.INPUT_MULTI_LINE_TEXT,
    FieldTypes.SINGLE_LINE_TEXT,
    FieldTypes.NUMBER,
];

export const LogicAnotherFieldsTypes: { [key: string]: FieldTypes[] } = {
    [FieldTypes.INPUT_MULTI_LINE_TEXT]: anotherCommon,
    [FieldTypes.SINGLE_LINE_TEXT]: anotherCommon,
    [FieldTypes.SCALE_RATING]: anotherRatingType,
    [FieldTypes.STAR_RATING]: anotherRatingType,
    [FieldTypes.TIMEZONE]: anotherTimezoneType,
    [FieldTypes.CHECKBOX]: anotherChoicesType,
    [FieldTypes.DROPDOWN]: anotherChoicesType,
    [FieldTypes.NUMBER]: anotherNumberType,
    [FieldTypes.RADIO]: anotherChoicesType,
    [FieldTypes.EMAIL]: anotherEmailType,
    [FieldTypes.PRICE]: anotherPriceType,
    [FieldTypes.NAME]: anotherCommon,
    [FieldTypes.URL]: anotherUrlType,
    [FieldTypes.TIME]: [FieldTypes.TIME],
    [FieldTypes.DATE]: [FieldTypes.DATE],
};

export const LogicStates = {
    [FieldTypes.INPUT_MULTI_LINE_TEXT]: textCommon,
    [FieldTypes.SINGLE_LINE_TEXT]: textCommon,
    [FieldTypes.SCALE_RATING]: ratingCommon,
    [FieldTypes.STAR_RATING]: ratingCommon,
    [FieldTypes.SIGNATURE]: simpleInputsCommon,
    [FieldTypes.FILE_UPLOAD]: simpleInputsCommon,
    [FieldTypes.PASSWORD]: simpleInputsCommon,
    [FieldTypes.TIMEZONE]: inputCommon,
    [FieldTypes.DROPDOWN]: checkboxCommon,
    [FieldTypes.CHECKBOX]: checkboxCommon,
    [FieldTypes.ADDRESS]: simpleInputsCommon,
    [FieldTypes.NUMBER]: numberInputCommon,
    [FieldTypes.PRICE]: inputCommon,
    [FieldTypes.EMAIL]: textCommon,
    [FieldTypes.PHONE]: simpleInputsCommon,
    [FieldTypes.TERMS]: simpleInputsCommon,
    [FieldTypes.RADIO]: checkboxCommon,
    [FieldTypes.TIME]: timeCommon,
    [FieldTypes.DATE]: dateCommon,
    [FieldTypes.NAME]: inputCommon,
    [FieldTypes.URL]: inputCommon,
    [FieldTypes.INPUT_TABLE]: inputCommon
};

export enum LogicRenderingComponents {
    DROPDOWN,
    TEXTINPUT,
    NUMBERINPUT,
    TIMEINPUT,
    DATEINPUT,
    URLINPUT,
}

interface IAllLogicTypes {
    [key: string]: LogicRenderingComponents;
}

interface ILogicSelectValueTypes {
    [key: string]: string;
}

export const AllLogicTypes: IAllLogicTypes = {
    //DATE
    "DATE.BEFORE.true": LogicRenderingComponents.DATEINPUT,
    "DATE.BEFORE.false": LogicRenderingComponents.DROPDOWN,
    "DATE.AFTER.true": LogicRenderingComponents.DATEINPUT,
    "DATE.AFTER.false": LogicRenderingComponents.DROPDOWN,
    "DATE.IS_EQUAL_TO_DATE.true": LogicRenderingComponents.DATEINPUT,
    "DATE.IS_EQUAL_TO_DATE.false": LogicRenderingComponents.DROPDOWN,
    "DATE.IS_NOT_EQUAL_TO_DATE.true": LogicRenderingComponents.DATEINPUT,
    "DATE.IS_NOT_EQUAL_TO_DATE.false": LogicRenderingComponents.DROPDOWN,
    "DATE.IS_EQUAL_TO_DAY.true": LogicRenderingComponents.DATEINPUT,
    "DATE.IS_EQUAL_TO_DAY.false": LogicRenderingComponents.DROPDOWN,
    "DATE.IS_NOT_EQUAL_TO_DAY.true": LogicRenderingComponents.DATEINPUT,
    "DATE.IS_NOT_EQUAL_TO_DAY.false": LogicRenderingComponents.DROPDOWN,
    //Single line text
    "INPUT_SINGLE_LINE_TEXT.IS.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_SINGLE_LINE_TEXT.IS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_SINGLE_LINE_TEXT.IS_NOT.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_SINGLE_LINE_TEXT.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_SINGLE_LINE_TEXT.CONTAINS.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_SINGLE_LINE_TEXT.CONTAINS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_SINGLE_LINE_TEXT.DOES_NOT_CONTAIN.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_SINGLE_LINE_TEXT.DOES_NOT_CONTAIN.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_SINGLE_LINE_TEXT.BEGINS_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_SINGLE_LINE_TEXT.BEGINS_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_SINGLE_LINE_TEXT.DOES_NOT_BEGIN_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_SINGLE_LINE_TEXT.DOES_NOT_BEGIN_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_SINGLE_LINE_TEXT.ENDS_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_SINGLE_LINE_TEXT.ENDS_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_SINGLE_LINE_TEXT.DOES_NOT_END_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_SINGLE_LINE_TEXT.DOES_NOT_END_WITH.false": LogicRenderingComponents.DROPDOWN,
    //MultiLine text
    "INPUT_MULTI_LINE_TEXT.IS.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_MULTI_LINE_TEXT.IS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_MULTI_LINE_TEXT.IS_NOT.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_MULTI_LINE_TEXT.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_MULTI_LINE_TEXT.CONTAINS.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_MULTI_LINE_TEXT.CONTAINS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_MULTI_LINE_TEXT.DOES_NOT_CONTAIN.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_MULTI_LINE_TEXT.DOES_NOT_CONTAIN.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_MULTI_LINE_TEXT.BEGINS_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_MULTI_LINE_TEXT.BEGINS_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_MULTI_LINE_TEXT.DOES_NOT_BEGIN_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_MULTI_LINE_TEXT.DOES_NOT_BEGIN_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_MULTI_LINE_TEXT.ENDS_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_MULTI_LINE_TEXT.ENDS_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_MULTI_LINE_TEXT.DOES_NOT_END_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_MULTI_LINE_TEXT.DOES_NOT_END_WITH.false": LogicRenderingComponents.DROPDOWN,
    //NAME
    "INPUT_NAME.IS.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_NAME.IS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_NAME.IS_NOT.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_NAME.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    //EMAIL
    "INPUT_EMAIL.IS.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_EMAIL.IS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_EMAIL.IS_NOT.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_EMAIL.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_EMAIL.CONTAINS.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_EMAIL.CONTAINS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_EMAIL.DOES_NOT_CONTAIN.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_EMAIL.DOES_NOT_CONTAIN.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_EMAIL.BEGINS_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_EMAIL.BEGINS_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_EMAIL.DOES_NOT_BEGIN_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_EMAIL.DOES_NOT_BEGIN_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_EMAIL.ENDS_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_EMAIL.ENDS_WITH.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_EMAIL.DOES_NOT_END_WITH.true": LogicRenderingComponents.TEXTINPUT,
    "INPUT_EMAIL.DOES_NOT_END_WITH.false": LogicRenderingComponents.DROPDOWN,
    //NUMBER
    "INPUT_NUMBER.IS.true": LogicRenderingComponents.NUMBERINPUT,
    "INPUT_NUMBER.IS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_NUMBER.IS_NOT.true": LogicRenderingComponents.NUMBERINPUT,
    "INPUT_NUMBER.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_NUMBER.CONTAINS.true": LogicRenderingComponents.NUMBERINPUT,
    "INPUT_NUMBER.CONTAINS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_NUMBER.DOES_NOT_CONTAIN.true": LogicRenderingComponents.NUMBERINPUT,
    "INPUT_NUMBER.DOES_NOT_CONTAIN.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_NUMBER.LESS_THAN.true": LogicRenderingComponents.NUMBERINPUT,
    "INPUT_NUMBER.LESS_THAN.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_NUMBER.GREATER_THAN.true": LogicRenderingComponents.NUMBERINPUT,
    "INPUT_NUMBER.GREATER_THAN.false": LogicRenderingComponents.DROPDOWN,
    //URL
    "INPUT_URL.IS.true": LogicRenderingComponents.URLINPUT,
    "INPUT_URL.IS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_URL.IS_NOT.true": LogicRenderingComponents.URLINPUT,
    "INPUT_URL.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    //PRICE
    "INPUT_PRICE.IS.true": LogicRenderingComponents.NUMBERINPUT,
    "INPUT_PRICE.IS.false": LogicRenderingComponents.DROPDOWN,
    "INPUT_PRICE.IS_NOT.true": LogicRenderingComponents.NUMBERINPUT,
    "INPUT_PRICE.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    //SCALE RAITING
    "SELECT_SCALE_RATING.LESS_THAN.true": LogicRenderingComponents.NUMBERINPUT,
    "SELECT_SCALE_RATING.LESS_THAN.false": LogicRenderingComponents.DROPDOWN,
    "SELECT_SCALE_RATING.GREATER_THAN.true": LogicRenderingComponents.NUMBERINPUT,
    "SELECT_SCALE_RATING.GREATER_THAN.false": LogicRenderingComponents.DROPDOWN,
    //STAR RAITING
    "SELECT_STAR_RATING.LESS_THAN.true": LogicRenderingComponents.NUMBERINPUT,
    "SELECT_STAR_RATING.LESS_THAN.false": LogicRenderingComponents.DROPDOWN,
    "SELECT_STAR_RATING.GREATER_THAN.true": LogicRenderingComponents.NUMBERINPUT,
    "SELECT_STAR_RATING.GREATER_THAN.false": LogicRenderingComponents.DROPDOWN,
    //TIME
    "TIME.IS.true": LogicRenderingComponents.TIMEINPUT,
    "TIME.IS.false": LogicRenderingComponents.DROPDOWN,
    "TIME.IS_NOT.true": LogicRenderingComponents.TIMEINPUT,
    "TIME.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    "TIME.BEFORE.true": LogicRenderingComponents.TIMEINPUT,
    "TIME.BEFORE.false": LogicRenderingComponents.DROPDOWN,
    "TIME.AFTER.true": LogicRenderingComponents.TIMEINPUT,
    "TIME.AFTER.false": LogicRenderingComponents.DROPDOWN,
    //TIMEZONE
    "TIME_ZONE.IS.true": LogicRenderingComponents.DROPDOWN,
    "TIME_ZONE.IS.false": LogicRenderingComponents.DROPDOWN,
    "TIME_ZONE.IS_NOT.true": LogicRenderingComponents.DROPDOWN,
    "TIME_ZONE.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    //CHECKBOX
    "SELECT_CHECKBOX.IS.true": LogicRenderingComponents.DROPDOWN,
    "SELECT_CHECKBOX.IS.false": LogicRenderingComponents.DROPDOWN,
    "SELECT_CHECKBOX.IS_NOT.true": LogicRenderingComponents.DROPDOWN,
    "SELECT_CHECKBOX.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    "SELECT_CHECKBOX.QUANTITY.true": LogicRenderingComponents.NUMBERINPUT,
    "SELECT_CHECKBOX.QUANTITY.false": LogicRenderingComponents.DROPDOWN,
    //RADIO
    "SELECT_RADIO.IS.true": LogicRenderingComponents.DROPDOWN,
    "SELECT_RADIO.IS.false": LogicRenderingComponents.DROPDOWN,
    "SELECT_RADIO.IS_NOT.true": LogicRenderingComponents.DROPDOWN,
    "SELECT_RADIO.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    "SELECT_RADIO.QUANTITY.true": LogicRenderingComponents.NUMBERINPUT,
    "SELECT_RADIO.QUANTITY.false": LogicRenderingComponents.DROPDOWN,
    //DROPDOWN
    "SELECT_DROPDOWN.IS.true": LogicRenderingComponents.DROPDOWN,
    "SELECT_DROPDOWN.IS.false": LogicRenderingComponents.DROPDOWN,
    "SELECT_DROPDOWN.IS_NOT.true": LogicRenderingComponents.DROPDOWN,
    "SELECT_DROPDOWN.IS_NOT.false": LogicRenderingComponents.DROPDOWN,
    "SELECT_DROPDOWN.QUANTITY.true": LogicRenderingComponents.NUMBERINPUT,
    "SELECT_DROPDOWN.QUANTITY.false": LogicRenderingComponents.DROPDOWN,
};

export const LogicSelectValueTypes: ILogicSelectValueTypes = {
    //DATE
    // "DATE.BEFORE": "Date Input",
    // "DATE.AFTER": "Date Input",
    // "DATE.IS_EQUAL_TO_DATE": "Select Day",
    // "DATE.IS_NOT_EQUAL_TO_DATE": "Select Day",
    // "DATE.IS_EQUAL_TO_DAY": "Date Input",
    // "DATE.IS_NOT_EQUAL_TO_DAY": "Date Input",
    //SCALE RAITING
    "SELECT_SCALE_RATING.LESS_THAN": "Number Input",
    "SELECT_SCALE_RATING.GREATER_THAN": "Number Input",
    //STAR RAITING
    "SSELECT_STAR_RATING.LESS_THAN": "Number Input",
    "SELECT_STAR_RATING.GREATER_THAN": "Number Input",
    //TIMEZONE
    "TIME_ZONE.IS": "Timezone",
    "TIME_ZONE.IS_NOT": "Timezone",
    //CHECKBOX
    "SELECT_CHECKBOX.IS": "Select Options",
    "SELECT_CHECKBOX.IS_NOT": "Select Options",
    "SELECT_CHECKBOX.QUANTITY": "Number Input",
    //RADIO
    "SELECT_RADIO.IS": "Select Options",
    "SELECT_RADIO.IS_NOT": "Select Options",
    "SELECT_RADIO.QUANTITY": "Number Input",
    //DROPDOWN
    "SELECT_DROPDOWN.IS": "Select Options",
    "SELECT_DROPDOWN.IS_NOT": "Select Options",
    "SELECT_DROPDOWN.QUANTITY": "Number Input",
};
